<template>
  <audio
    ref="audioPlayer"
    class="video-js vjs-big-play-centered" />
</template>

<script>
import videojs from 'video.js';
import 'video.js/dist/video-js.css';

export default {
  name: 'audio-player',
  props: {
    options: {
      type: Object,
      default() {
        return {};
      },
    },
    disableScrub: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      player: null,
      highestTime: 0,
    };
  },
  mounted() {
    this.player = videojs(this.$refs.audioPlayer, {
      ...this.options,
    }, () => {
      this.player.on('ended', this.onEnded);
      this.player.on('ready', this.onReady);
    });
    videojs.use('*', this.disableForwardScrubbing);
  },
  beforeUnmount() {
    if (this.player) {
      this.player.dispose();
    }
  },
  methods: {
    onEnded() {
      this.$emit('on-ended');
    },
    onReady() {
      this.$emit('on-ready');
    },
    disableForwardScrubbing(player) {
      const $vm = this;
      return {
        setSource(srcObj, next) {
          next(null, srcObj);
        },
        currentTime(time) {
          if (time > $vm.highestTime) {
            $vm.highestTime = time;
          }
          return time;
        },
        setCurrentTime(desiredTime) {
          const currentTime = player.currentTime();
          if (!$vm.disableScrub || desiredTime < $vm.highestTime) {
            return desiredTime;
          }
          return currentTime;
        },
      };
    },
  },
};
</script>

<style scoped lang="scss">
.video-js {
  height: 450px;
  width: 100%;

  @media only screen and (max-width: $mobile-max) {
    height: 335px;
    width: 100%;
  }
}
</style>
